export class Stores {
   public Id: number;
   public StoreName: string;
}
